import { request } from "configs/api";
import { SearchQuery, SearchResponse } from "interfaces/common";
import { ReportDto, SubmitReportDto } from "interfaces/report";

class ReportService {
  search(query?: SearchQuery): Promise<SearchResponse<ReportDto>> {
    return request({
      url: "/admin/reports/list",
      method: "GET",
      params: query || {},
    });
  }

  async create(data: SubmitReportDto): Promise<void> {
    await request({
      data,
      url: "/admin/reports/create",
      method: "POST",
    });
  }

  async update(id: string, data: SubmitReportDto): Promise<void> {
    await request({
      data,
      url: `/admin/reports/update/${id}`,
      method: "PUT",
    });
  }

  async getById(id: string): Promise<ReportDto> {
    return await request({
      url: `/admin/reports/get/${id}`,
      method: "GET",
    });
  }

  async delete(id: string): Promise<void> {
    await request({
      url: `/admin/reports/delete/${id}`,
      method: "DELETE",
    });
  }
}

export const reportService: ReportService = new ReportService();
